module.exports = __webpack_public_path__ + "static/img/so.f91fb92c.svg";